import React from "react";

const PrimaryButtons = ({
  label,
  onClick,
  downloading = false,
  minWidth = 60,
  isDisable = false,
}) => {
  return (
    <button
      className={`min-w-[${minWidth}px]
      } h-10 rounded-lg bg-primary disabled:bg-[#836e61f9] hover:bg-primary-hover selection:bg-primary-hover py-[6px] px-4 cursor-pointer disabled:cursor-default`}
      onClick={onClick}
      disabled={isDisable ? isDisable : downloading}
    >
      {downloading ? (
        <div className=" w-full flex justify-center">
          <div className="w-4 h-4 border-2  border-solid  border-t-0 border-r-0 border-white rounded-full animate-spin"></div>
        </div>
      ) : (
        <p className="text-[14px] text-center font-semibold leading-7 text-white">
          {label}
        </p>
      )}
    </button>
  );
};

const SecondaryButtons = ({ label, onClick, minWidth = 60 }) => {
  return (
    <div
      className={`min-w-[${minWidth}px] h-10 rounded-lg bg-surface-dark hover:bg-surface-hover selection:bg-gray-300 py-[6px] px-4 cursor-pointer`}
      onClick={onClick}
    >
      <p className="text-[14px] whitespace-nowrap font-semibold text-center leading-7 text-gray-primary">
        {label}
      </p>
    </div>
  );
};

const OutlineButtons = ({ label, onClick, minWidth = 60 }) => {
  return (
    <div
      className={`min-w-[${minWidth}px] outline outline-1 w-full h-10 rounded-lg  hover:bg-surface-hover selection:bg-gray-300 py-[6px] px-4 cursor-pointer`}
      onClick={onClick}
    >
      <p className="text-[14px] font-semibold text-center leading-7 text-gray-primary">
        {label}
      </p>
    </div>
  );
};

export { PrimaryButtons, SecondaryButtons, OutlineButtons };
